// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__spoqaHanSans_e0c701', '__spoqaHanSans_Fallback_e0c701'"},"className":"__className_e0c701"};